export default __webpack_public_path__ + "static/media/Zuzanna_Buchwald_von_Salm_AHV_In_Moms_We_Trust.7195c017.jpg";